import { Component, Input, EventEmitter, Output, Inject } from '@angular/core';
import { User } from '../manage-access.model';
import { USER_STATUS } from '../manage-access.constant';
import {
  LOB,
  LOB_BEHAVIORAL,
  LOB_MEDBH,
  LOB_MEDICAL,
  LOB_OHP,
} from '@cigna/chcp/auth/util';
import { AppContext } from '@cigna/chcp/shared/util';
import { APP_CONTEXT } from '@cigna/chcp/shared/environment-util';

@Component({
  selector: 'cigna-user-status-item',
  templateUrl: './user-status-item.component.html',
  styleUrls: ['./user-status-item.component.scss'],
})
export class UserStatusItemComponent {
  USER_STATUS = USER_STATUS;
  @Input() user: User;
  @Input() amUserId = '';
  @Output() removeAccessForUser = new EventEmitter();
  @Output() resetPasswordForUser = new EventEmitter();

  constructor(@Inject(APP_CONTEXT) public appContext: AppContext) {}

  canShowRemove = (user: User): boolean => this.amUserId !== user.id;

  canShowReset = (user: User): boolean =>
    user.id !== null && this.amUserId !== user.id && !user.temporaryUserName;

  hasChcpAcccess = (user: User): boolean =>
    user.tins.some((tin) =>
      [LOB_MEDBH, LOB_MEDICAL, LOB_OHP].includes(tin.lob as LOB),
    );

  hasEvernorthAcccess = (user: User): boolean =>
    user.tins.some((tin) =>
      [LOB_MEDBH, LOB_BEHAVIORAL].includes(tin.lob as LOB),
    );
}
